<template>
  <div class="my_waterfall">
    <waterfall
      :autoResize="true"
      :moveTransitionDuration="0.5"
      :col-width="300"
      :list="imgsArr"
      ref="waterfall"
      class="waterfall"
      :class="{ cut_arr_empty: cutArrEmpty }"
    >
      <div
        class="waterfall_item animated"
        :class="{ fadeInUp: item.state == 'show' }"
        slot-scope="item"
        @click="clickItem(item.data)"
      >
        <img
          class="waterfall-img ta3"
          :class="{ model_img: comType == 2 }"
          :src="item.data.src"
          @load="imgLoad"
        />

        <!-- 作品广场 -->
        <div class="img_info" v-if="comType == 1">
          <div class="img_collect ta3" @click.stop="userCollect(item.data)">
            <i
              class="iconfont ta3"
              :class="
                item.data.is_collect ? 'icon-alreadyCollect' : 'icon-collect'
              "
            ></i>
          </div>

          <div class="work_box ta3">
            <p class="img_title toh">
              {{ item.data.works_name }}
            </p>
            <div class="author_box">
              <div class="author_left">
                <img
                  :src="$prefixSrc(item.data.author_url)"
                  alt=""
                  class="author_img"
                />
                <p class="toh">
                  {{ item.data.author_name }}
                </p>
              </div>
              <div class="author_right">
                <div class="icon_item">
                  <i class="iconfont icon-eye"></i>
                  {{ item.data.watch_number }}
                </div>
                <div class="icon_item">
                  <i class="iconfont icon-collect"></i>
                  {{ item.data.collect_num }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 模型广场 -->
        <div class="model_info" v-else-if="comType == 2">
          <div class="model_name toh">{{ item.data.name }}</div>
          <div class="model_times">
            <i class="iconfont icon-times"></i>
            <span>{{ item.data.create_times }}</span>
          </div>
        </div>

        <!-- 个人作品管理 -->
        <div class="personal_info" :class="{ open_del: batchDel }" v-else>
          <div
            class="del_box ta3"
            :class="{ del_bg: item.data.isdel }"
            v-if="batchDel"
            @click.stop="addDel(item)"
          >
            <div class="del_select">
              <div class="del_icon ta3" :class="{ on_del: item.data.isdel }">
                <i class="el-icon-success"></i>
              </div>
            </div>
          </div>
          <div
            class="work_type"
            v-if="!listInfo.is_collect && item.data.app_status != null"
          >
            <div class="work_type_box" v-if="item.data.app_status != 1">
              <div class="work_tag status1" v-if="!item.data.app_status">
                待审核
              </div>
              <el-tooltip
                effect="dark"
                :content="item.data.app_desc"
                placement="bottom"
                v-else
              >
                <div class="work_tag status2">审核不通过</div>
              </el-tooltip>
            </div>
            <div class="work_type_box" v-else>
              <div class="work_tag publish1" v-if="item.data.is_publish">
                已发布
              </div>
              <div class="work_tag publish2" v-else>待发布</div>
            </div>
          </div>
          <div
            class="work_del ta3"
            @click.stop="managementWorks(item.data, 1)"
            v-if="!listInfo.is_collect"
          >
            <i class="el-icon-delete ta3"></i>
          </div>
          <div
            class="img_collect ta3"
            @click.stop="managementWorks(item.data, 2)"
            v-else
          >
            <i class="iconfont ta3 icon-alreadyCollect"></i>
          </div>
        </div>
      </div>
    </waterfall>
    <div class="loading_box" v-show="loading">
      <span
        class="waterfall_loading"
        :class="{ fadeIn: loading }"
        :style="{ color: loadingColor }"
      >
        <i v-for="(item, index) in 12" :key="index"></i>
      </span>
    </div>

    <div v-if="finished" class="finished_box">
      <router-link
        to="/studentcms"
        class="list_more ta3 waterfall_over animated"
        :class="{ headShake: finished }"
        v-if="overType == 1"
        >查看更多</router-link
      >

      <div
        class="no_more waterfall_over animated"
        :class="{ tada: finished }"
        v-else
      >
        没有更多数据了~
      </div>
    </div>
  </div>
</template>

<script>
import { workCollect } from "@/api/stuWorkdtcms";
import { getToken } from "@/utils/auth";

export default {
  name: "myWaterfall",
  props: {
    imgsArr: {
      type: Array,
      default: [],
    },
    comType: {
      type: Number,
      default: 1, // 1 作品广场 2 模型广场 3 个人作品管理
    },
    overType: {
      type: Number,
      default: 1, // 1 首页作品广场 2 作品广场 3 模型广场 4 个人作品管理
    },
    listInfo: {
      type: Object,
      default: "",
    },
    // 滚动条距离底部小于 offset 时触发
    offset: {
      type: Number,
      default: 50,
    },

    // 加载颜色
    loadingColor: {
      type: String,
      default: "#6257ff",
    },
    batchDel: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      finished: false,
      loading: true,
      cutArrEmpty: false,
      imgTimer: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollBindFn);
    this.$refs.waterfall.onRender = (res) => {
      // 瀑布流渲染完毕
      this.loading = false;
      this.preloaded();
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollBindFn);
  },
  computed: {
    // 滚动
    scrollBindFn() {
      return this.$throttle(this.handleScroll, 200);
    },
  },
  methods: {
    clickItem(value) {
      localStorage.setItem("routeBack", this.$route.path);
      let objListInfo;
      switch (this.comType) {
        case 1:
          objListInfo = this.listInfo;
          objListInfo.page = value.page;
          localStorage.setItem("workListInfo", JSON.stringify(objListInfo));
          this.$router.push(`/stuWorkdtcms/${value.id}`);
          break;
        case 2:
          objListInfo = this.listInfo;
          objListInfo.page = value.page;
          localStorage.setItem("modelListInfo", JSON.stringify(objListInfo));
          localStorage.setItem("modelBack", this.$route.path);
          this.$router.push(`/modelDetails/${value.id}`);
          break;
        case 3:
          let type = 1;
          if (this.listInfo.is_collect) type = 2;
          this.$router.push(`/stuWorkdtcms/${value.id}/${type}`);
          break;
      }
    },
    over() {
      this.loading = false;
      this.finished = true;
    },
    preloaded() {
      let scrollable = this.isScrollable(
        document.documentElement || document.body
      );
      if (!scrollable) {
        this.$emit("getList", false);
      }
    },
    isScrollable(element) {
      return element.scrollHeight - this.offset > element.clientHeight;
    },
    managementWorks(data, type) {
      let obj = { data, type };
      this.$emit("managementWorks", obj);
    },

    handleScroll() {
      if (this.finished || this.loading) return;
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight + this.offset > scrollHeight) {
        this.loading = true;
        this.$emit("getList", false);
      }
    },
    // 重置
    reset(type) {
      this.finished = false;
      this.loading = true;
      switch (type) {
        case 1:
          this.cutArrEmpty = false;
          // 切换列表需要手动重置瀑布流样式数组
          this.styleArrReset(false);
          break;
        case 2:
          this.cutArrEmpty = true;
          break;
      }
    },

    // 重置瀑布流样式数组
    styleArrReset(repaints, i, delL) {
      if (repaints) {
        this.$refs.waterfall.styleArr.splice(i, delL);
        this.waterfallRepaints(0, 0.8);
      } else {
        this.$refs.waterfall.styleArr = [];
      }
    },

    // 瀑布流重绘
    waterfallRepaints(i = 0, duration = 0.5) {
      this.$refs.waterfall.repaints(i, duration);
    },

    // 收藏
    userCollect(val) {
      if (getToken()) {
        let obj = { work_id: val.id };
        if (val.is_collect) {
          obj.op = 0;
        } else {
          obj.op = 1;
        }
        workCollect(obj).then((res) => {
          if (res.status) {
            val.is_collect = obj.op;
            if (obj.op) {
              val.collect_num++;
            } else {
              val.collect_num--;
            }
          }
        });
      } else {
        eventBus.$emit("openLoginDialog");
      }
    },
    imgLoad() {
      this.debounce(this.waterfallRepaints, 150);
    },
    debounce(fn, delay) {
      if (this.imgTimer) clearTimeout(this.imgTimer);
      this.imgTimer = setTimeout(() => {
        fn();
      }, delay);
    },

    // 添加删除
    addDel(val) {
      if (val.data.isdel) {
        val.data.isdel = false;
      } else {
        val.data.isdel = true;
      }
      this.$emit("addBatchDel", { id: val.data.id, state: val.data.isdel });
    },
  },
  watch: {
    imgsArr(newV, oldV) {
      let newL = newV.length,
        oldL = oldV.length;
      if (newL && !oldL) {
        this.reset(1);
      }
      if ((!newL && oldL) || (!newL && !oldL)) {
        this.reset(2);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my_waterfall {
  .cut_arr_empty {
    height: 80px !important;
  }
  .waterfall {
    /deep/ .item {
      padding: 10px;
    }

    .waterfall_item {
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 100%;
      border-radius: 5px;

      /deep/ .waterfall-img {
        width: 100%;
      }

      .img_collect {
        position: absolute;
        right: -50px;
        top: 15px;
        width: 40px;
        height: 40px;
        background: rgba(0, 0, 0, 0.39);
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          i {
            color: #ff5757;
          }
        }

        i {
          font-size: 22px;
          color: #fff;
        }

        .icon-alreadyCollect {
          color: #ff5757;
        }
      }

      .img_info {
        width: 100%;
        height: 100%;

        .work_box {
          position: absolute;
          bottom: 0;
          color: #ccc;
          font-size: 14px;
          line-height: 18px;
          width: 100%;
          min-height: 40%;
          background: linear-gradient(
            180deg,
            rgba(26, 36, 55, 0) 0%,
            #000000 100%
          );
          // transform: translateY(0px);
          transform: translateY(190px);
          padding: 0 8px 16px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          box-sizing: border-box;

          .author_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;

            .author_left {
              display: flex;
              align-items: center;
              gap: 5px;
              max-width: 60%;

              .author_img {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                flex-shrink: 0;
              }
            }

            .author_right {
              display: flex;
              align-items: center;
              gap: 12px;

              .icon_item {
                display: flex;
                align-items: center;
                gap: 6px;

                i {
                  font-size: 12px;
                }
              }
            }
          }
        }
      }

      .model_info {
        width: 100%;
        height: 52px;
        position: absolute;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 0 8px;
        color: #ccc;
        box-sizing: border-box;

        .model_name {
          font-size: 16px;
          flex: 1;
        }

        .model_times {
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }

      .personal_info {
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;

        .del_box {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;

          .del_select {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            overflow: hidden;
            border: 2px solid #fff;
            position: absolute;
            top: 10px;
            right: 10px;
            display: flex;
            align-items: center;
            justify-content: center;

            .del_icon {
              width: 0;
              height: 0;
              border-radius: 50%;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ff5757;

              i {
                font-size: 30px;
              }
            }

            .on_del {
              width: 100%;
              height: 100%;
            }
          }
        }

        .del_bg {
          background: rgba(0, 0, 0, 0.3);
        }

        .work_type {
          margin: 15px 0 0 16px;

          .work_tag {
            height: 25px;
            border-radius: 5px;
            text-align: center;
            line-height: 25px;
            font-size: 12px;
            color: #fff;
            padding: 0 12px;
            display: inline-block;
          }
          .work_type_box {
            text-align: left;
            .status1 {
              background: #909399;
            }
            .status2 {
              background: #f56c6c;
            }
            .publish1 {
              background: #6257ff;
            }
            .publish2 {
              background: #409eff;
            }
          }
        }

        .work_del {
          position: absolute;
          right: -50px;
          top: 15px;
          width: 25px;
          height: 25px;
          background: rgba(0, 0, 0, 0.39);
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            i {
              color: #6257ff;
            }
          }

          i {
            font-size: 15px;
            color: #fff;
          }
        }
      }

      &:hover {
        .img_collect {
          right: 10px;
        }

        .img_info {
          .work_box {
            transform: translateY(0);
          }
        }

        .model_img {
          transform: scale(1.1);
        }

        .personal_info:not(.open_del) {
          .work_del {
            right: 10px;
          }
        }
      }
    }
  }

  .loading_box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;

    .waterfall_loading {
      width: 35px;
      height: 35px;
      box-sizing: border-box;
      animation: loading-rotate 0.8s linear infinite;
      animation-timing-function: steps(12);
      position: relative;
      display: inline-block;

      i {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;

        &::before {
          width: 2px;
          height: 25%;
          content: " ";
          display: block;
          margin: 0 auto;
          border-radius: 40%;
          background-color: currentColor;
        }
      }
    }
  }

  .finished_box {
    text-align: center;
    color: #aaa;
    padding-top: 20px;

    .list_more {
      display: inline-block;
      width: 150px;
      height: 50px;
      border: 2px solid var(--font_color);
      border-radius: 25px;
      text-align: center;
      line-height: 50px;
      font-size: 16px;
      color: var(--font_color);
      margin: 0 auto;

      &:hover {
        color: #6257ff;
        border-color: #6257ff;
      }
    }

    .no_more {
      display: inline-block;
    }
  }
}

@keyframes loading-rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@for $i from 1 through 12 {
  .waterfall_loading i:nth-of-type(#{$i}) {
    opacity: calc(1 - (0.75 / 12) * (#{$i} - 1));
    transform: rotate(calc(#{$i} * 30deg));
  }
}
</style>



// WEBPACK FOOTER //
// src/components/myWaterfall.vue